// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Category } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { icon1: Category };

// ==============================|| MENU ITEMS - category ||============================== //

const category: NavItemType = {
  id: 'group-category',
  type: 'group',
  icon: icons.icon1,
  name: 'Categories',
  children: [
    {
      icon: icons.icon1,
      id: 'category',
      title: <FormattedMessage id="Category" />,
      type: 'item',
      url: '/category'
    }
  ]
};

export default category;
